/**
 * SliderCustomLabel Container Component
 *
 * Handles theme state and passes it to the view for rendering custom slider labels.
 * @remarks
 * - Determines dark mode from theme provider
 * - Passes marker values and theme state to view
 */

import React from "react";

import SliderCustomLabelView from "./SliderCustomLabelView";

import { useTheme } from "@/providers/ThemeProvider";

/**
 * Props for SliderCustomLabel container
 */
interface Props {
  oneMarkerValue: number | string;
  twoMarkerValue?: number | string;
  /** Left offset of the first thumb's CENTRE, in px along the track. */
  oneMarkerLeftPosition?: number;
  /** Left offset of the second thumb's CENTRE, in px along the track. */
  twoMarkerLeftPosition?: number;
}

/**
 * SliderCustomLabel container component that manages theme state
 * @param props - Component props
 * @param props.oneMarkerValue - Value for the first (left) marker
 * @param props.twoMarkerValue - Optional value for the second (right) marker
 * @param props.oneMarkerLeftPosition - Left offset of the first thumb's centre
 * @param props.twoMarkerLeftPosition - Left offset of the second thumb's centre
 */
const SliderCustomLabel = ({
  oneMarkerValue,
  twoMarkerValue,
  oneMarkerLeftPosition,
  twoMarkerLeftPosition,
}: Props) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <SliderCustomLabelView
      oneMarkerValue={oneMarkerValue}
      twoMarkerValue={twoMarkerValue}
      oneMarkerLeftPosition={oneMarkerLeftPosition}
      twoMarkerLeftPosition={twoMarkerLeftPosition}
      isDark={isDark}
    />
  );
};

export default SliderCustomLabel;
